import { render, staticRenderFns } from "./viewCommissionStatement.vue?vue&type=template&id=a0069a14&scoped=true&"
import script from "./viewCommissionStatement.vue?vue&type=script&lang=js&"
export * from "./viewCommissionStatement.vue?vue&type=script&lang=js&"
import style0 from "./viewCommissionStatement.vue?vue&type=style&index=0&id=a0069a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0069a14",
  null
  
)

export default component.exports